import { PublicClientApplication, EventType } from '@azure/msal-browser'
import type { AuthenticationResult } from '@azure/msal-browser'
import { msalConfig } from '@/config/authConfig'

/**
 * Single shared MSAL instance for the app. Must be initialized (async)
 * before it is passed to MsalProvider — see src/main.tsx.
 */
export const msalInstance = new PublicClientApplication(msalConfig)

export async function initializeMsal(): Promise<void> {
  await msalInstance.initialize()

  const existingAccounts = msalInstance.getAllAccounts()
  if (existingAccounts.length > 0 && !msalInstance.getActiveAccount()) {
    msalInstance.setActiveAccount(existingAccounts[0])
  }

  msalInstance.addEventCallback((event) => {
    if (
      (event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
      event.payload
    ) {
      const result = event.payload as AuthenticationResult
      if (result.account) {
        msalInstance.setActiveAccount(result.account)
      }
    }
  })

  // Complete any in-flight redirect (kept for resilience; interactive
  // sign-in primarily uses the popup flow — see useAuthFlow).
  await msalInstance.handleRedirectPromise().catch(() => undefined)
}
